<div class="popBg" id="nv-buy-now-model" style="display: none;">
		<div class="popBody">
		   <div class="popHead">
			  <a class="popClose"></a>
			  <div class="popHeadtxt">product_title_place</div>
		   </div>
		   <div class="popblock">
			  <div class="popContent">
				 <div class="popRow">
					<div class="popCell cellLogo"><img src="" title="retailer"></div>
					<div class="popCell cellStock">
					   <div class="stock_class_place">stock_status_place</div>
					</div>
					<div class="popCell cellBundle" style="is_display_place_none">
					   <div class="modal-popover">
						  <div>
							 <span class="bundle_icon_place">bundel_lable_place</span>
							 <div class="modal-tooltip">
								<span class="modal-popover-prompt modal-bundle-width">
								   <span class="text">bundel_text_place</span>
								</span>
								<div class="modal-tooltip-pointer" style="margin-left: 0px"></div>
							 </div>
						  </div>
					   </div>
					</div>
					<div class="popCell cellPrice">price_place</div>
					<div class="popCell cellBtn"><a href="purchase_link_place" class="load-buy-link" target="_blank">BUY NOW</a></div>
				 </div>
			  </div>
			</div>
	 
		   <div class="popFooter"><p></p></div>
		</div>
	 </div>
	 <div style="display:none;"><a href="" id="nv-buy-pdp-url" target="_blank"></a></div>
<!-- <div #hoc *ngIf="hatchOverlayDisplay === 'block'" class="hatch-overlay-container" [style.display]="hatchOverlayDisplay"
 (click)="closeOverlay($event, hoc)" (window:keyup)="closeOverlay($event, hoc)">
	<div *ngIf="!showSpinner" class="hatch-overlay">
		<div class="hatch-overlay-header">
			<input type="button" class="hatch-overlay-button" (click)="hideHatchOverlay()" />
		</div>
		<div *ngIf="retailInfo" class="hatch-overlay-body">
			<div class="product-info-container">
				<div class="product-image-container"><img title="{{productDetail.displayName}} {{ 'graphics_cards' | translate }}"
					 src='{{productDetail.imageURL}}' class="product-image" (load)="resizeImg($event.target, thumbnailW, thumbnailH)"
					 (error)="showImgError($event.target)"></div>
				<div class="product-title-container"><span style="margin: auto 0;">{{productDetail.productTitle}}</span></div>
			</div>
			<div *ngIf="screenWidth === 'SM'" class="hatch-main">
				<div *ngFor="let item of retailInfo" class="etailer-container">
					<div class="logo-container"><img src='{{item.retailerLogo}}' class="logo"></div>
					<div class="hatch-price-stock-container">
						<div class="hatch-price-container-sm"><span class="hatch-price">{{item.productPrice}}</span></div>
						<div class="hatch-stock-container-sm"><a href='{{item.purchaseLink}}' target="_blank" class="buy-link" style="font-weight: normal; color: #76b900; background-color: transparent"><span>{{
									'check_availability' | translate }}</span></a></div>
					</div>
					<div class="hatch-buy-container"><a href='{{item.purchaseLink}}' target="_blank" class="buy-link" style="line-height: 24px;">{{getBuyButtonText(locale)
							| translate }}</a></div>
				</div>
			</div>
			<div *ngIf="screenWidth !== 'SM'" class="hatch-main">
				<div *ngFor="let item of retailInfo" class="etailer-container">
					<div class="logo-container"><img src='{{item.retailerLogo}}' class="logo"></div>
					<div class="hatch-price-container"><span class="hatch-price">{{item.productPrice}}</span></div>
					<div class="hatch-stock-container"><a href='{{item.purchaseLink}}' target="_blank" class="buy-link" style="font-weight: normal; color: #76b900; background-color: transparent"><span>{{
								'check_availability' | translate }}</span></a></div>
					<div class="hatch-buy-container"><a href='{{item.purchaseLink}}' target="_blank" class="buy-link" style="line-height: 24px;">{{getBuyButtonText(locale)
							| translate }}</a></div>
				</div>
			</div>
		</div>
	</div>
</div> -->